import React, { useEffect } from 'react';
import { Menu, MenuItem, Tooltip, IconButton, Badge, makeStyles } from '@material-ui/core';
import { LanguageOutlined } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import translate from '../../i18next/funcTranslateHelper';
import { allLanguages } from '../../constants/lang';

const useStyles = makeStyles((theme) => ({
  myClassName: {
    color: '#F96500',
    position: 'relative'
  },
  iconButton: {
    [theme.breakpoints.down(990)]: {
      marginRight: '10px',
      '& span span svg': {
        fontSize: '1.3rem'
      }
    },
    color: theme.palette.primary.main,
    position: 'relative'
  }
}));

const ChangeLanguage = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { i18n } = useTranslation();
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const { language: detectedLanguage } = i18n;
    const languageOnly = detectedLanguage.split('-')[0];

    i18n.changeLanguage(languageOnly);
  }, [i18n]);

  return (
    <div style={{ position: 'absolute', top: 0, right: 20, padding: '20px' }}>
      <Tooltip className='lang-changeLang' title={translate('ChangeLanguage:tooltip')}>

        <IconButton
          aria-controls='simple-menu'
          aria-haspopup='true'
          onClick={handleClick}
          className={classes.iconButton}
        >
          <Badge
            badgeContent={i18n.language}
            className={classes.myClassName}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
          >
            <LanguageOutlined fontSize='large' />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock
      >
        {allLanguages.map((lang) =>
          <MenuItem
            key={lang} onClick={() => {
              i18n.changeLanguage(lang);
              handleClose();
              localStorage.setItem('lang', 'es');
            }}
          >
            {lang} - {translate(`ChangeLanguage:language:${lang}`)}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default withRouter(ChangeLanguage);
